type QuotationMarksProps = {
	className?: string
}

export default function QuotationMarks({ className }: QuotationMarksProps) {
	return (
		<svg
			width="42"
			height="30"
			viewBox="0 0 42 30"
			className={className}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M8.47478 30C5.81602 30 3.73887 29.0417 2.24332 27.125C0.747774 25.125 0 22.625 0 19.625C0 13.9583 1.86944 9.33333 5.60831 5.75C9.43027 2.08333 14.3739 0.166665 20.4392 0L20.0653 5.875C16.4095 6.125 13.543 7.08333 11.4659 8.75C9.47181 10.4167 8.14243 12.4167 7.47775 14.75C7.1454 15.75 7.06231 16.7083 7.22849 17.625C8.14243 16.5417 9.47181 16 11.2166 16C13.0445 16 14.4985 16.5417 15.5786 17.625C16.7418 18.625 17.3234 20.0833 17.3234 22C17.3234 24.3333 16.4926 26.25 14.8309 27.75C13.2522 29.25 11.1335 30 8.47478 30ZM30.0356 30C27.3769 30 25.2997 29.0417 23.8042 27.125C22.3086 25.125 21.5608 22.625 21.5608 19.625C21.5608 13.9583 23.4303 9.33333 27.1691 5.75C30.9911 2.08333 35.9347 0.166665 42 0L41.6261 5.875C37.9703 6.125 35.1039 7.08333 33.0267 8.75C31.0326 10.4167 29.7033 12.4167 29.0386 14.75C28.7062 15.75 28.6231 16.7083 28.7893 17.625C29.7033 16.5417 31.0326 16 32.7775 16C34.6053 16 36.0593 16.5417 37.1395 17.625C38.3027 18.625 38.8843 20.0833 38.8843 22C38.8843 24.3333 38.0534 26.25 36.3917 27.75C34.8131 29.25 32.6944 30 30.0356 30Z" />
		</svg>
	)
}
